import { Card, Col, Row, Button, Image } from 'antd';
import Title from 'antd/lib/typography/Title';
import { CalendarOutlined, CloudOutlined, DollarCircleOutlined, FileExcelOutlined, LineChartOutlined, MailOutlined, SettingOutlined, TeamOutlined, UserSwitchOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from 'react';
import { AuthProvider } from '../../Providers/authProvider';
import { AuthenticatedUser } from '../../Types/AuthenticatedUser';
import { TextService } from '../../Services/TextService';
import Paragraph from 'antd/lib/typography/Paragraph';
import Page from '../../Components/Page/Page';
import { getCurrentLanguage } from '../../Helpers/RouteHelper';
import feature1Image from '../../Images/feature1.jpg';
import feature2Image from '../../Images/feature2.jpg';
import feature3Image from '../../Images/feature3.jpg';

const FeaturesMemberOrganisations = () => {
  const navigation = useNavigate();
  const [user, setUser] = useState(null as AuthenticatedUser | null);
  const GetText = TextService.GetText;

  useEffect(() => {
    AuthProvider().GetLoggedInUser().then(user => {
      setUser(user);
    });
  }, []);

  return <Page pageTitle={GetText("PageTitle_MemberOrganisations")}>
    {/* Hero Section */}
    <div style={{
      background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 50%, #234E70 100%)',
      padding: '80px 0',
      color: '#234E70',
      textAlign: 'center'
    }}>
      <Row justify="center">
        <Col xs={20} sm={16} md={12}>
          <Title level={1} style={{ color: '#234E70', fontSize: '3rem', marginBottom: '20px' }}>
            {GetText("FeaturesMemberOrganisations_Header")}
          </Title>
          <Paragraph style={{
            color: '#495057',
            fontSize: '18px',
            lineHeight: '1.6',
            marginBottom: '30px'
          }}>
            {GetText("FeaturesMemberOrganisations_Description")}
          </Paragraph>
          <Button
            type="primary"
            size="large"
            style={{
              background: '#234E70',
              border: 'none',
              color: 'white',
              height: '50px',
              fontSize: '16px',
              borderRadius: '25px'
            }}
            icon={<ArrowRightOutlined />}
            onClick={() => navigation("/" + getCurrentLanguage() + "/CreateUser")}
          >
            {GetText("FeaturesMemberOrganisations_GetStarted")}
          </Button>
        </Col>
      </Row>
    </div>

    {/* Features Section */}
    <div style={{ padding: '80px 0', background: '#f8f9fa' }}>
      <Row justify="center">
        <Col xs={22} sm={20} md={18} lg={16}>
          <Title level={2} style={{ textAlign: 'center', marginBottom: '60px', color: '#333' }}>
            {GetText("FeaturesMemberOrganisations_PowerfulFeatures")}
          </Title>

          {/* Feature 1 - Member Management */}
          <div style={{
            background: 'white',
            borderRadius: '20px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
            border: '1px solid #e8e8e8',
            marginBottom: '40px',
            overflow: 'hidden'
          }}>
            <Row align="middle" gutter={0}>
              <Col xs={24} md={12} style={{ padding: 0 }}>
                <div style={{ margin: 0, padding: 0, height: '310px', overflow: 'hidden' }}>
                  <Image
                    src={feature1Image}
                    alt="Member Management Dashboard - Shows member list with profiles, contact details, and management options"
                    width="100%"
                    height={310}
                    style={{ objectFit: 'cover' }}
                    preview={false}
                    fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg=="
                  />
                </div>
              </Col>
              <Col xs={24} md={12}>
                <div style={{ padding: '35px' }}>
                  <TeamOutlined style={{
                    fontSize: '48px',
                    color: '#52c41a',
                    marginBottom: '20px',
                    display: 'block'
                  }} />
                  <Title level={3} style={{ color: '#333', marginBottom: '16px' }}>
                    {GetText("FeaturesMemberOrganisations_Feature1Title")}
                  </Title>
                  <Paragraph style={{ color: '#666', fontSize: '16px', lineHeight: '1.6' }}>
                    <span dangerouslySetInnerHTML={{ __html: GetText("FeaturesMemberOrganisations_Feature1Text") }}></span>
                  </Paragraph>
                </div>
              </Col>
            </Row>
          </div>

          {/* Feature 2 - Email Communications */}
          <div style={{
            background: 'white',
            borderRadius: '20px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
            border: '1px solid #e8e8e8',
            marginBottom: '40px',
            overflow: 'hidden'
          }}>
            <Row align="middle" gutter={0}>
              <Col xs={24} md={12} style={{ padding: 0 }}>
                <div style={{ margin: 0, padding: 0 }}>
                  <Image
                    src={feature2Image}
                    alt="Email Communication Interface - Shows email templates, member communication tools, and messaging dashboard"
                    width="100%"
                    height={310}
                    style={{ objectFit: 'cover' }}
                    preview={false}
                    fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg=="
                  />
                </div>
              </Col>
              <Col xs={24} md={12}>
                <div style={{ padding: '35px' }}>
                  <MailOutlined style={{
                    fontSize: '48px',
                    color: '#fa8c16',
                    marginBottom: '20px',
                    display: 'block'
                  }} />
                  <Title level={3} style={{ color: '#333', marginBottom: '16px' }}>
                    {GetText("FeaturesMemberOrganisations_Feature2Title")}
                  </Title>
                  <Paragraph style={{ color: '#666', fontSize: '16px', lineHeight: '1.6' }}>
                    <span dangerouslySetInnerHTML={{ __html: GetText("FeaturesMemberOrganisations_Feature2Text") }}></span>
                  </Paragraph>
                </div>
              </Col>
            </Row>
          </div>

          {/* Feature 3 - Cloud Storage */}
          <div style={{
            background: 'white',
            borderRadius: '20px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
            border: '1px solid #e8e8e8',
            marginBottom: '60px',
            overflow: 'hidden'
          }}>
            <Row align="middle" gutter={0}>
              <Col xs={24} md={12} style={{ padding: 0 }}>
                <div style={{ margin: 0, padding: 0, height: '310px', overflow: 'hidden' }}>
                  <Image
                    src={feature3Image}
                    alt="Cloud Storage Dashboard - Shows file management, data backup, and cloud synchronization features"
                    width="100%"
                    height={310}
                    style={{ objectFit: 'cover' }}
                    preview={false}
                    fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg=="
                  />
                </div>
              </Col>
              <Col xs={24} md={12}>
                <div style={{ padding: '35px' }}>
                  <CloudOutlined style={{
                    fontSize: '48px',
                    color: '#1890ff',
                    marginBottom: '20px',
                    display: 'block'
                  }} />
                  <Title level={3} style={{ color: '#333', marginBottom: '16px' }}>
                    {GetText("FeaturesMemberOrganisations_Feature3Title")}
                  </Title>
                  <Paragraph style={{ color: '#666', fontSize: '16px', lineHeight: '1.6' }}>
                    <span dangerouslySetInnerHTML={{ __html: GetText("FeaturesMemberOrganisations_Feature3Text") }}></span>
                  </Paragraph>
                </div>
              </Col>
            </Row>
          </div>

          {/* Additional Features Grid */}
          <Title level={3} style={{ textAlign: 'center', marginBottom: '40px', color: '#333' }}>
            {GetText("FeaturesMemberOrganisations_MoreFeatures")}
          </Title>
          <Row gutter={[24, 24]}>
            <Col xs={24} sm={12} lg={8}>
              <Card
                style={{
                  borderRadius: '16px',
                  border: 'none',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                  height: '100%'
                }}
                bodyStyle={{ padding: '30px' }}
              >
                <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                  <LineChartOutlined style={{ fontSize: '40px', color: '#722ed1' }} />
                </div>
                <Title level={4} style={{ textAlign: 'center', marginBottom: '16px' }}>
                  {GetText("FeaturesMemberOrganisations_Feature4Title")}
                </Title>
                <Paragraph style={{ color: '#666', textAlign: 'center' }}>
                  <span dangerouslySetInnerHTML={{ __html: GetText("FeaturesMemberOrganisations_Feature4Text") }}></span>
                </Paragraph>
              </Card>
            </Col>
            <Col xs={24} sm={12} lg={8}>
              <Card
                style={{
                  borderRadius: '16px',
                  border: 'none',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                  height: '100%'
                }}
                bodyStyle={{ padding: '30px' }}
              >
                <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                  <SettingOutlined style={{ fontSize: '40px', color: '#8c8c8c' }} />
                </div>
                <Title level={4} style={{ textAlign: 'center', marginBottom: '16px' }}>
                  {GetText("FeaturesMemberOrganisations_Feature5Title")}
                </Title>
                <Paragraph style={{ color: '#666', textAlign: 'center' }}>
                  <span dangerouslySetInnerHTML={{ __html: GetText("FeaturesMemberOrganisations_Feature5Text") }}></span>
                </Paragraph>
              </Card>
            </Col>
            <Col xs={24} sm={12} lg={8}>
              <Card
                style={{
                  borderRadius: '16px',
                  border: 'none',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                  height: '100%'
                }}
                bodyStyle={{ padding: '30px' }}
              >
                <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                  <DollarCircleOutlined style={{ fontSize: '40px', color: '#52c41a' }} />
                </div>
                <Title level={4} style={{ textAlign: 'center', marginBottom: '16px' }}>
                  {GetText("FeaturesMemberOrganisations_Feature6Title")}
                </Title>
                <Paragraph style={{ color: '#666', textAlign: 'center' }}>
                  <span dangerouslySetInnerHTML={{ __html: GetText("FeaturesMemberOrganisations_Feature6Text") }}></span>
                </Paragraph>
              </Card>
            </Col>
            <Col xs={24} sm={12} lg={8}>
              <Card
                style={{
                  borderRadius: '16px',
                  border: 'none',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                  height: '100%'
                }}
                bodyStyle={{ padding: '30px' }}
              >
                <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                  <CalendarOutlined style={{ fontSize: '40px', color: '#f5222d' }} />
                </div>
                <Title level={4} style={{ textAlign: 'center', marginBottom: '16px' }}>
                  {GetText("FeaturesMemberOrganisations_Feature7Title")}
                </Title>
                <Paragraph style={{ color: '#666', textAlign: 'center' }}>
                  <span dangerouslySetInnerHTML={{ __html: GetText("FeaturesMemberOrganisations_Feature7Text") }}></span>
                </Paragraph>
              </Card>
            </Col>
            <Col xs={24} sm={12} lg={8}>
              <Card
                style={{
                  borderRadius: '16px',
                  border: 'none',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                  height: '100%'
                }}
                bodyStyle={{ padding: '30px' }}
              >
                <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                  <UserSwitchOutlined style={{ fontSize: '40px', color: '#a0522d' }} />
                </div>
                <Title level={4} style={{ textAlign: 'center', marginBottom: '16px' }}>
                  {GetText("FeaturesMemberOrganisations_Feature8Title")}
                </Title>
                <Paragraph style={{ color: '#666', textAlign: 'center' }}>
                  <span dangerouslySetInnerHTML={{ __html: GetText("FeaturesMemberOrganisations_Feature8Text") }}></span>
                </Paragraph>
              </Card>
            </Col>
            <Col xs={24} sm={12} lg={8}>
              <Card
                style={{
                  borderRadius: '16px',
                  border: 'none',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                  height: '100%'
                }}
                bodyStyle={{ padding: '30px' }}
              >
                <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                  <FileExcelOutlined style={{ fontSize: '40px', color: '#52c41a' }} />
                </div>
                <Title level={4} style={{ textAlign: 'center', marginBottom: '16px' }}>
                  {GetText("FeaturesMemberOrganisations_Feature9Title")}
                </Title>
                <Paragraph style={{ color: '#666', textAlign: 'center' }}>
                  <span dangerouslySetInnerHTML={{ __html: GetText("FeaturesMemberOrganisations_Feature9Text") }}></span>
                </Paragraph>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>

    {/* Call to Action Section */}
    <div style={{
      background: 'linear-gradient(135deg, #e9ecef 0%, #dee2e6 50%, #234E70 100%)',
      padding: '60px 0',
      textAlign: 'center'
    }}>
      <Row justify="center">
        <Col xs={20} sm={16} md={12}>
          <Title level={2} style={{ color: '#234E70', marginBottom: '20px' }}>
            {GetText("FeaturesMemberOrganisations_ReadyTitle")}
          </Title>
          <Paragraph style={{
            color: '#495057',
            fontSize: '18px',
            marginBottom: '30px'
          }}>
            {GetText("FeaturesMemberOrganisations_ReadyDescription")}
          </Paragraph>
          <Button
            type="primary"
            size="large"
            style={{
              background: '#234E70',
              border: 'none',
              color: 'white',
              height: '50px',
              fontSize: '16px',
              borderRadius: '25px',
              fontWeight: 'bold'
            }}
            onClick={() => navigation("/" + getCurrentLanguage() + "/CreateUser")}
          >
            {GetText("FeaturesMemberOrganisations_StartTrial")}
          </Button>
        </Col>
      </Row>
    </div>
  </Page>
};

export default FeaturesMemberOrganisations;